module.exports = __webpack_public_path__ + "img/int13.6b4af9b8.jpg";